import { css } from '@emotion/react';

export const facilitiesStyles = {
    container: css({
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        marginBottom: '16px',
        marginTop: '16px',
    }),
    facilityTag: css({
        padding: '6px 12px',
        backgroundColor: '#F5F5F5',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 600,
        color: '#1A1A1A',
        whiteSpace: 'nowrap',
    }),
};
